"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = translate;

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _i18nContext = _interopRequireDefault(require("./i18n-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// higher order decorator for components that need `t`
function translate() {
  return function (WrappedComponent) {
    var _translate = function _translate(props) {
      return _react["default"].createElement(_i18nContext["default"].Consumer, null, function (t) {
        return _react["default"].createElement(WrappedComponent, _extends({}, props, {
          t: t
        }));
      });
    };

    return (0, _hoistNonReactStatics["default"])(_translate, WrappedComponent);
  };
}